import type { ReactNode } from 'react';
import ApiError from 'src/api/ApiError';
import ErrorMessage from 'src/components/errorMessage/ErrorMessage';
import { Spinner } from 'src/components/ui/spinner';

/**
 * One Demand forecasting tab's body: a one-line explanation with the tab's
 * actions on the right, then the content, or the loading/error state the page
 * shell would otherwise have drawn. The layout owns the page header.
 */
export function DemandForecastingTab({
  description,
  actions,
  isLoading = false,
  error,
  children,
}: {
  description: ReactNode;
  actions?: ReactNode;
  isLoading?: boolean;
  error?: Error | ApiError | null;
  children: ReactNode;
}) {
  return (
    <div>
      <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
        <p className="max-w-3xl text-xs text-muted-foreground">{description}</p>
        {actions ? (
          <div className="flex items-center gap-2">{actions}</div>
        ) : null}
      </div>
      {isLoading ? (
        <div className="flex justify-center py-6">
          <Spinner />
        </div>
      ) : error ? (
        <div className="flex justify-center p-3">
          <ErrorMessage error={error} />
        </div>
      ) : (
        children
      )}
    </div>
  );
}
